import styled from "styled-components";
import { fontFamilies } from "components/shared/tokens/typography";

const COLORS = {
  text: "#293142",
  muted: "#7b8498",
};

export const DesktopPageTabs = styled.div`
  display: flex;
  width: 100%;
  height: 54px;
  opacity: 1;
  border-bottom: 1px solid var(--color-base-grey-200, rgba(230, 233, 239, 1));
  gap: 0;
`;

export const DesktopPageTab = styled.button`
  width: 140px;
  height: 54px;
  opacity: 1;
  gap: 10px;
  padding: 16px;
  margin: 0;
  border: 0;
  border-bottom: 2px solid
    ${(props) => (props.$active ? "var(--color-base-red-500, rgba(239, 79, 95, 1))" : "transparent")};
  background: ${(props) => (props.$active ? "linear-gradient(180deg, #F4F6FB 0%, #FFEDEF 100%)" : "transparent")};
  color: ${(props) => (props.$active ? COLORS.text : COLORS.muted)};
  font-family: ${(props) =>
    props.$active ? fontFamilies.semiBold : fontFamilies.regular};
  font-size: 14px;
  cursor: pointer;
`;

export const MobilePageTabs = styled.div`
  display: flex;
  width: 100%;
`;

export const MobilePageTab = styled.button`
  flex: 1;
  height: 39.38px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: none;
  background: ${(props) =>
    props.$active
      ? "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFEDEF 100%)"
      : "transparent"};
  font-family: ${(props) =>
    props.$active ? fontFamilies.semiBold : fontFamilies.regular};
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0;
  color: ${(props) => (props.$active ? COLORS.text : COLORS.muted)};
  cursor: pointer;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: var(--color-base-red-500, rgba(239, 79, 95, 1));
    opacity: ${(props) => (props.$active ? 1 : 0)};
  }
`;
